import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe, getSortedLanguageList, IconNames, Language, LANGUAGE_BY_DEFAULT } from '../../../common';
import { AppFacade } from '../../../store';
import { filter } from 'rxjs/operators';
import { CONTACT_EMAIL, USER_GUIDE } from '../../../common/constants/contact-info';
import { CONTACT_PHONE_NUMBER, RAISE_TICKET_URL } from '../../../common/constants/contact-info';

@Component({
  selector: 'login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class LoginHeaderComponent implements OnInit {
  languageControl: FormControl<Language>;
  languageList: Language[] = getSortedLanguageList();
  subscriptions: Subscription[] = [];
  contactEmail = CONTACT_EMAIL;
  userGuide = USER_GUIDE;
  raiseTicketUrl = RAISE_TICKET_URL;
  contactPhoneNumber = CONTACT_PHONE_NUMBER;
  iconNameList = IconNames;

  constructor(private appFacade: AppFacade) {}

  ngOnInit(): void {
    this.languageControl = new FormControl<Language>(LANGUAGE_BY_DEFAULT);
    this.subscriptions.push(
      this.languageControl.valueChanges.subscribe((language: Language) => {
        this.appFacade.changeLang(language);
      }),
      this.appFacade.currentLanguage$
        .pipe(filter(Boolean))
        .subscribe((language: Language) => this.languageControl.setValue(language, { emitEvent: false })),
    );
  }

  protected readonly language = Language;
}
